import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_ENDORSEMENTS } from 'lib/quoteBind/queryKeys';
// app
import { enqueueNotification, hideModal } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const useDeclineEndorsementQuote = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.risks.useDeclineEndorsementQuote',
    };

    dispatch(enqueueNotification('notification.generic.request', 'error'));
    dispatch(hideModal());

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    queryClient.invalidateQueries([QB_RISK_ENDORSEMENTS, res?.riskId]);

    dispatch(hideModal());
    dispatch(enqueueNotification('notification.declineEndorsementQuote.success', 'success'));
  };

  return useMutation(
    async (params) => {
      const { endorsementId, declineReason } = params;

      if (!endorsementId) {
        throw new Error('useDeclineEndorsementQuote: endorsementId is required');
      }

      const result = await quoteBindAxios.put(`/endorsements/${endorsementId}/decline`, { reason: declineReason ?? '' });
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
